import { render, staticRenderFns } from "./IviewPage.vue?vue&type=template&id=1ec3fe80&scoped=true&"
import script from "./IviewPage.vue?vue&type=script&lang=js&"
export * from "./IviewPage.vue?vue&type=script&lang=js&"
import style0 from "./IviewPage.vue?vue&type=style&index=0&id=1ec3fe80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec3fe80",
  null
  
)

export default component.exports